import { defineStore } from "pinia";

export const useDialogStore = defineStore("dialogStore", {
  state: () => ({
    isDialogVisible: false,
    oneTimeVisible: false,
    zIndexValue: 40
  }),
  actions: {
    showDialog() {
      this.isDialogVisible = true;
    },
    hideDialog() {
      this.isDialogVisible = false;
    },
  },
});
